import React from "react";
import LoginForm from "../auth/components/LoginForm";

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
